import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { GeneralDialog } from 'sharedComponents/GeneralDialog';
import { IconInfoFilled } from 'svgIcons/MotionPortalIcons';
import colors from 'theme/_colors.scss';
import './style.scss';
import { refreshGateway } from './actions';

const RefreshGatewayComponent = ({ show, close, gatewayID }) => {
    const { t: translate } = useTranslation();
    const dispatch = useDispatch();

    const content = <div className='refresh-gateway__content'>
        <p>{translate('ABB.Powertrain.Frontend.gatewayRefreshNetaHeadingDescription')}</p>
        <ul className='refresh-gateway__list'>
            <li>{translate('ABB.Powertrain.Frontend.gatewayRefreshNetaUpdateConnectivityDescription')}</li>
            <li>{translate('ABB.Powertrain.Frontend.gatewayRefreshNetaPredefinedSignalDescription')}</li>
            <li>{translate('ABB.Powertrain.Frontend.gatewayRefreshNetaDebuggerFileDescription')}</li>
        </ul>
        <p className='refresh-gateway__content-text'>{translate('ABB.Powertrain.Frontend.gatewayRefreshNetaOperationTimeDescription')}</p>
    </div>;

    const getRefreshGatewayTitle = <h1 className='refresh-gateway__title'>
        <IconInfoFilled color={colors.primaryInfo} />
        <span className='refresh-gateway__title-text'>{translate('ABB.Powertrain.Frontend.gatewayRefreshNetaTitle')}</span>
    </h1>;
    return <GeneralDialog
        show={show}
        close={close}
        title={getRefreshGatewayTitle}
        dialogClassName='refresh-gateway__dialog'
        closeButton={true}
        cancelButtonProps={{
            text: translate('ABB.Powertrain.Frontend.cancelLabel'),
        }}
        acceptButtonProps={{
            text: translate('ABB.Powertrain.Frontend.gatewayRefreshNetaButtonLabel'),
            onClick: () => {
                dispatch(refreshGateway(gatewayID));
                close();
            }
        }}
    >
        {content}
    </GeneralDialog>;
};

RefreshGatewayComponent.propTypes = {
    show: PropTypes.bool,
    close: PropTypes.func,
    gatewayID: PropTypes.string,
};

export default RefreshGatewayComponent;
